export interface NotifyMessage {
  id: string
  title: string
  content: string
  read: boolean
  createdTime: number
  moduleCode: number
  submoduleCode: number
  bizType: number
  hasLink: boolean
  dataJson?: string
  jumpLink?: string
}

export interface NavItem {
  value: number
  label: string
  code?: number
  submodule?: SubModule[]
}

export interface SubModule {
  code: number
  name: string
}

// 不需要跳转的消息类型
export const NO_LINK_TYPES = [15, 16, 5]

// 标签类型映射
export const LABEL_TYPES = [
  { type: 105, name: 'home_v11_LatestAnnouncement' },
  { type: 106, name: 'home_v11_SystemMaintenanceAndUpdate' },
  { type: 107, name: 'home_v11_OtherAnnouncements' },
  // ...其他标签类型
]

// 导航列表配置
export const NAV_LIST = [
  { value: 0, submodule: [] }, //全部
  { value: 1, code: 2, submodule: [] }, //公告
  { value: 2, code: 1, submodule: [] }, //系统
  { value: 3, code: 20, submodule: [] }, //行情
  { value: 4, code: 21, submodule: [] }, //交易
]

// 标签类型映射表
export const LABEL_LIST = [
  { type: 105, name: 'home_v11_LatestAnnouncement' }, // 最新公告
  { type: 106, name: 'home_v11_SystemMaintenanceAndUpdate' }, // 系统维护与更新
  { type: 107, name: 'home_v11_OtherAnnouncements' }, // 其他公告
  { type: 108, name: 'home_v11_Hotspot' }, // 热点消息
  { type: 109, name: 'home_v11_Event' }, // 活动消息
  { type: 110, name: 'home_v11_NewbieTask' }, // 新手任务
  { type: 111, name: 'home_v11_Rewards' }, // 奖励发放
  { type: 112, name: 'home_v11_ServiceNotification' }, // 服务通知
  { type: 113, name: 'home_v11_TradeOther' }, // 交易其他
  { type: 114, name: 'home_v11_DayTrading' }, // 日内交易
  { type: 115, name: 'home_v11_Withdrawal' }, // 提币提现
  { type: 116, name: 'home_v11_Authentication' }, // 认证通知
  { type: 117, name: 'home_v11_CopyTrade' }, // 跟单通知
]
